module.exports = __webpack_public_path__ + "img/defense_recovered_left.de06dc2e.jpg";